'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});

exports.greyScale = void 0;
exports.greyScale = {
  black: 'rgb(16,24,40)',
  95: 'rgb(29,37,51)',
  90: 'rgb(39,47,61)',
  80: 'rgb(61,69,85)',
  60: 'rgb(121,126,139)',
  40: 'rgb(181,183,192)',
  20: 'rgb(211,212,219)',
  10: 'rgb(232,232,238)',
  5: 'rgb(244,244,245)',
  white: 'rgb(255,255,255)',
};
